import Container from './styled/Container'

const H1 = Container

export default H1
